module.exports = __webpack_public_path__ + "static/media/tour-thumb.af1f76f9.png";